import ApplicationAdapter from "./application";

export default class PrivateNetworkAdapter extends ApplicationAdapter {
  urlForFindRecord(id) {
    return `${this.apiBaseUri}/privatenetwork/details?privatenetworkid=${id}`;
  }

  urlForCreateRecord() {
    return `${this.apiBaseUri}/privatenetwork/create`;
  }

  urlForUpdateRecord(id) {
    return `${this.apiBaseUri}/privatenetwork/edit?privatenetworkid=${id}`;
  }

  urlForDeleteRecord(id) {
    return `${this.apiBaseUri}/privatenetwork/delete?privatenetworkid=${id}`;
  }
}
